import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpServiceProvider {

  URL_API = '50.114.32.141'
  constructor(public http: HttpClient) { }

  getDadosServidor(endpoint) {
    return this.http.get('http://' + this.URL_API + '/ateccardapioonline/response/listarInfo.php?url=' + endpoint);
  }

  getAPI(endpoint) {
    return this.http.get('http://' + this.URL_API + '/ateccardapioonline/response/' + endpoint + '.php?bd=' + localStorage.getItem("database") + '&numFilial=' + localStorage.getItem("filial")).timeout(20000);
  }

  getLOCAL(endpoint) {
    return this.http.get('http://' + localStorage.getItem("ipservidor") + ':' + localStorage.getItem("porta") + '/datasnap/rest/TServerMethods/' + `${endpoint}`).timeout(20000);
  }

  post(body, headers) {
    return this.http.post('http://' + localStorage.getItem("ipservidor") + ':' + localStorage.getItem("porta") + '/datasnap/rest/TServerMethods/inserirProduto', body, headers)
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-service/http-service.ts